const SoFormStepConfiguration = {
  nameForData: 'SO_FORM_STEP_CONFIGURATION',
};

export default SoFormStepConfiguration;
